import { computed, ref } from 'vue'

export type DateRange = [Date, Date]

export function isDateRange(value: unknown): value is DateRange {
  return (
    Array.isArray(value) &&
    value.length === 2 &&
    value.every((date) => date instanceof Date && !Number.isNaN(date.getTime()))
  )
}

export function useRequiredDateRange(initialRange: DateRange) {
  const range = ref<DateRange>(initialRange)
  const pickerRange = computed<DateRange | null>({
    get: () => range.value,
    set: (value) => {
      if (isDateRange(value)) range.value = value
    }
  })

  return { range, pickerRange }
}
